import React, { useState, useEffect, createContext } from 'react';

const DarkModeContext = createContext(null);

const DarkModeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  const handleDarkModeChange = (event) => {
    setIsDarkMode(event.matches);
  };

  useEffect(() => {
    // 현재 브라우저의 다크 모드 여부를 확인하는 미디어 쿼리
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    // 페이지가 로드될 때와 다크 모드가 변경될 때 이벤트 리스너 등록
    darkModeMediaQuery.addEventListener('change', handleDarkModeChange);
    handleDarkModeChange(darkModeMediaQuery); // 초기 다크 모드 여부 설정

    // 컴포넌트가 언마운트될 때 이벤트 리스너 해제
    return () => {
      darkModeMediaQuery.removeEventListener('change', handleDarkModeChange);
    };
  }, []);

  return (
    <DarkModeContext.Provider value={isDarkMode}>
      {children}
    </DarkModeContext.Provider>
  );
};

export {DarkModeProvider, DarkModeContext};
